export enum CompanyType {
  GROUPEMENT = 'groupement',
  CHAIN = 'chain',
  INDUSTRY = 'industry',
  PHARMACY = 'pharmacy',
  PARAPHARMACY = 'parapharmacy',
  /** Société opératrice : sociétés internes du groupe + partenaires opérant un module
   *  avec des accès admin (School Belgique, Sound Italie…). */
  OPERATOR = 'operator',
  /** Union regionale : les pharmacies de son territoire lui sont rattachees par code postal. */
  URPS = 'urps',
  STUDENT = 'student',
  DOCTOR = 'doctor',
  NURSE = 'nurse',
  MIDWIFE = 'midwife',
  VETERINARY = 'veterinary',
  PHYSIOTHERAPIST = 'physiotherapist',
  PSYCHOLOGIST = 'psychologist',
}

/** Types professionnels de sante hors officine (PDS). */
export const HEALTH_PROFESSIONAL_COMPANY_TYPES = [
  CompanyType.DOCTOR,
  CompanyType.NURSE,
  CompanyType.MIDWIFE,
  CompanyType.VETERINARY,
  CompanyType.PHYSIOTHERAPIST,
  CompanyType.PSYCHOLOGIST,
]

/**
 * Libellé traduit d'un type de company (clés enum.companyType.*) — retombe sur la
 * valeur brute pour un type sans clé. Utilisé par les chips/colonnes de la gestion
 * des entreprises.
 */
export const getCompanyTypeLabel = (t: (key: any) => string, type?: string | null): string => {
  if (!type) return ''
  const known = Object.values(CompanyType).includes(type as CompanyType)
  return known ? t(`enum.companyType.${type}`) : type
}

/**
 * Lookup type -> libellé pour le FILTRE de colonne « Type » de la liste des entreprises.
 * Types métier courants uniquement (les professions PDS ont leur propre liste dédiée).
 */
export const COMPANY_TYPE_FILTER_LOOKUP = (t: (key: any) => string): Record<string, string> => ({
  [CompanyType.PHARMACY]: t('enum.companyType.pharmacy'),
  [CompanyType.PARAPHARMACY]: t('enum.companyType.parapharmacy'),
  [CompanyType.INDUSTRY]: t('enum.companyType.industry'),
  [CompanyType.GROUPEMENT]: t('enum.companyType.groupement'),
  [CompanyType.CHAIN]: t('enum.companyType.chain'),
  [CompanyType.OPERATOR]: t('enum.companyType.operator'),
  [CompanyType.URPS]: t('enum.companyType.urps'),
})

/** Libelles traduits des professions PDS, indexes par CompanyType. */
export const getHealthProfessionalTypeLabels = (t: (key: any) => string) => ({
  [CompanyType.DOCTOR]: t('enum.companyType.doctor'),
  [CompanyType.NURSE]: t('enum.companyType.nurse'),
  [CompanyType.MIDWIFE]: t('enum.companyType.midwife'),
  [CompanyType.VETERINARY]: t('enum.companyType.veterinary'),
  [CompanyType.PHYSIOTHERAPIST]: t('enum.companyType.physiotherapist'),
  [CompanyType.PSYCHOLOGIST]: t('enum.companyType.psychologist'),
})

export default CompanyType
